import TableRow from '@mui/material/TableRow';
import CustomCell from './CustomCell';

const CustomRow = ({ row, columns }) => (
  <TableRow hover>
    {columns.map((column) => (
      <CustomCell
        key={column.id}
        value={row[column.id]}
        column={column}
        row={row}
      />
    ))}
  </TableRow>
);

export default CustomRow;
